export default __webpack_public_path__ + "static/media/placeholderDoctor.ec2321b1.png";